<div id="productToMobilView" *ngIf="diviceXs || diviceSm">

    <div id="content-filter">
        <div id="btn-filter" fxLayout="row" fxLayoutAlign="start center" (click)="drawer.toggle()">
            <span class="material-icons"> filter_alt </span>
            <p>Filtrar</p>
        </div>
    </div>


    <mat-sidenav-container fxFlexFill class="example-container">
        <mat-sidenav #drawer position="end">
          
            <app-filters [productName]="'Celulares'"></app-filters>
           
        </mat-sidenav>
      
        <mat-sidenav-content fxFlexFill>
      
            <div id="listaProducts" fxFlexFill>
                <div *ngFor="let product of products" id="productItem">
                    <app-product-card [product]="product" [diviceXs]="diviceXs" [diviceSm]="diviceSm"></app-product-card>
                </div>
        
                <div *ngIf="products.length ===0">
                    <h2>No tenemos productos aún para esa categoría</h2>
                </div>
            </div>
      
        </mat-sidenav-content>
      
      </mat-sidenav-container>

  

</div>

<div id="productToNormalView" *ngIf="!diviceXs && !diviceSm" fxLayout="row" >
    <app-filters ></app-filters>

    <div id="listaProducts">
        <div *ngFor="let product of products" id="productItem">
            <app-product-card [product]="product" [diviceXs]="diviceXs" [diviceSm]="diviceSm"></app-product-card>
        </div>

        <div *ngIf="products.length ===0">
            <h2>No tenemos productos aún para esa categoría</h2>
        </div>
    </div>
</div>